import { ChevronDown } from 'lucide-react';
import ParticleBackground from '../components/ParticleBackground';
import StatCounter from '../components/StatCounter';
import { PROJECT_INFO, HERO_STATS } from '../data/mockData';

// 区块1：震撼首屏
export default function Section01Hero() {
  const scrollToNext = () => {
    const el = document.getElementById('background');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="hero" className="relative min-h-screen w-full flex flex-col justify-center items-center overflow-hidden">
      <ParticleBackground />

      {/* 主内容 */}
      <div className="relative z-10 text-center px-8 max-w-[1600px]">
        <h1 className="text-6xl lg:text-8xl font-black mb-6 tracking-wider">
          <span className="text-gradient-gold">「数师有方」</span>
        </h1>
        <h2 className="text-3xl lg:text-5xl font-bold text-white mb-8 tracking-wide">
          数学师范生AI微格实训平台
        </h2>
        <p className="text-xl lg:text-3xl text-cyan font-medium mb-12 tracking-widest">
          AI赋能师范培养 · 数据驱动教学成长 · 双师联动县域教育
        </p>

        <div className="inline-block px-8 py-4 rounded-full border border-gold/30 bg-deepBlue/60 backdrop-blur-md mb-12">
          <p className="text-xl lg:text-2xl text-gold font-bold">
            全国首个数学学科专用轻量级AI微格平台
          </p>
        </div>

        {/* 团队信息 */}
        <div className="flex flex-wrap justify-center gap-6 text-lg lg:text-xl text-slate-300 mb-16">
          <span className="px-4 py-2 bg-white/5 rounded-lg">{PROJECT_INFO.school}</span>
          <span className="px-4 py-2 bg-white/5 rounded-lg">
            指导教师：{PROJECT_INFO.teachers.join(' · ')}
          </span>
          <span className="px-4 py-2 bg-white/5 rounded-lg">{PROJECT_INFO.date}</span>
        </div>
      </div>

      {/* 核心数据跑马灯 */}
      <div className="absolute bottom-24 left-0 w-full overflow-hidden z-10">
        <div className="marquee-track">
          {[...HERO_STATS, ...HERO_STATS].map((stat, index) => (
            <div
              key={index}
              className="flex items-center gap-8 px-12 text-2xl lg:text-3xl whitespace-nowrap"
            >
              <span className="text-slate-400 font-medium">{stat.label}</span>
              <span className="text-gold font-black text-4xl lg:text-5xl">
                <StatCounter value={stat.value} suffix={stat.suffix} />
              </span>
              <span className="text-gold/50">·</span>
            </div>
          ))}
        </div>
      </div>

      {/* 向下滚动提示 */}
      <button
        onClick={scrollToNext}
        className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 text-gold scroll-hint"
      >
        <ChevronDown className="w-12 h-12" />
      </button>
    </section>
  );
}
